import script from "./HeaderPricingInformation.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderPricingInformation.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderPricingInformation.vue?vue&type=style&index=0&id=d1275a6e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1275a6e"]])

export default __exports__